module.exports = __webpack_public_path__ + "static/media/logo-supplydrop.47ff3a60.svg";